import React from 'react';
import { Box, Typography, TextField, FormControl, Select, MenuItem } from '@mui/material';
import FormSection from './design-system/FormSection';
import { fieldSx, labelSx, coberturaCardSx, menuProps } from '../styles/formStyles';

function LF({ label, children }) {
  return (
    <Box>
      <Typography sx={labelSx}>{label}</Typography>
      {children}
    </Box>
  );
}

// Único conjunto de campos de un Paciente — lo usan tanto el módulo Pacientes (crear/editar)
// como "Nuevo turno → Nuevo paciente". Un solo lugar para agregar, sacar o cambiar un campo;
// la Obra Social siempre se elige de la lista real, nunca como texto libre.
//
// `errores` (opcional): { campo: mensaje } de validarCamposPaciente — muestra el mensaje
// debajo del campo correspondiente (Política de Identificación del Paciente).
// `dniReadOnly` + `accionesDni`: el DNI deja de editarse acá una vez creado el paciente;
// la corrección pasa por un flujo dedicado (ver Pacientes.js).
export default function PacienteCamposForm({
  form, setForm, obrasSociales = [], autoFocusNombre = false,
  errores = {}, dniReadOnly = false, accionesDni = null,
}) {
  const f = field => e => setForm(prev => ({ ...prev, [field]: e.target.value }));

  return (
    <>
      <FormSection title="Identificación" first>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '10px' }}>
          <LF label="Nombre *">
            <TextField fullWidth value={form.nombre} onChange={f('nombre')} sx={fieldSx} autoFocus={autoFocusNombre}
              error={!!errores.nombre} helperText={errores.nombre || ''} />
          </LF>
          <LF label="Apellido *">
            <TextField fullWidth value={form.apellido} onChange={f('apellido')} sx={fieldSx}
              error={!!errores.apellido} helperText={errores.apellido || ''} />
          </LF>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '10px' }}>
          <LF label="DNI *">
            <TextField fullWidth value={form.dni} onChange={f('dni')} sx={fieldSx}
              disabled={dniReadOnly}
              error={!!errores.dni} helperText={errores.dni || ''} />
            {accionesDni}
          </LF>
          <LF label="Fecha de nacimiento *">
            <TextField type="date" fullWidth value={form.fecha_nacimiento} onChange={f('fecha_nacimiento')}
              inputProps={{ style: { color: '#e0e0e0', colorScheme: 'dark' } }} sx={fieldSx}
              error={!!errores.fecha_nacimiento} helperText={errores.fecha_nacimiento || ''} />
          </LF>
        </Box>
      </FormSection>

      <FormSection title="Contacto">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '10px' }}>
          <LF label="Email *">
            <TextField type="email" fullWidth value={form.email} onChange={f('email')} sx={fieldSx}
              error={!!errores.email} helperText={errores.email || ''} />
          </LF>
          <LF label="Teléfono *">
            <TextField fullWidth value={form.telefono} onChange={f('telefono')} sx={fieldSx}
              error={!!errores.telefono} helperText={errores.telefono || ''} />
          </LF>
        </Box>
        <LF label="Dirección">
          <TextField fullWidth value={form.direccion} onChange={f('direccion')} sx={fieldSx} />
        </LF>
      </FormSection>

      <FormSection title="Cobertura médica">
        <Box sx={coberturaCardSx}>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '2fr 1fr' }, gap: '10px' }}>
            <LF label="Obra social">
              <FormControl fullWidth sx={fieldSx}>
                <Select displayEmpty value={form.obra_social} onChange={f('obra_social')}
                  MenuProps={menuProps} sx={{ color: 'var(--c-texto)' }}>
                  <MenuItem value=""><em style={{ color: '#888' }}>Sin especificar</em></MenuItem>
                  {obrasSociales.map(os => (
                    <MenuItem key={os.id} value={os.nombre}>{os.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </LF>
            <LF label="N° afiliado">
              <TextField fullWidth value={form.numero_afiliado} onChange={f('numero_afiliado')} sx={fieldSx} />
            </LF>
          </Box>
        </Box>
      </FormSection>
    </>
  );
}
